import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
    verifyPayment,
    createSubscription,
    registerEvent,
    storeCrmPricing,
    activateStartups,
    activateEvent,
    saveStartupIdea,
    applyForMeeting
} from '../utils/api';

import { PaymentType } from '../utils/paymentTypes';
import axios from 'axios';

const PaymentCallback = () => {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { type, orderId } = useParams();

    const startupId = localStorage.getItem('startupId');
    const matrimonyUserId = localStorage.getItem('matrimonyUserId');
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        let toastId = null;
console.log("🔥 type param from URL:", type);
console.log("🟦 PaymentType.STARTUP_IDEAS:", PaymentType.STARTUP_IDEAS);
console.log("EQUAL? ->", type === PaymentType.STARTUP_IDEAS);
        const runVerification = async () => {
            try {
                toast.dismiss();
                toastId = toast.loading("Processing your payment...");

                if (!orderId) {
                    toast.update(toastId, {
                        render: "No order ID provided",
                        type: "error",
                        isLoading: false,
                        autoClose: 5000
                    });

                    setTimeout(() => {
                        if (type === PaymentType.MATRIMONY) navigate('/matrimony');
                        if (type === PaymentType.EVENT) navigate('/events');
                        if (type === PaymentType.CRM) navigate('/crm-pricing');
                        if (type === PaymentType.SUBSCRIPTION) navigate('/funding');
                        if (type === PaymentType.FUNDING) navigate('/funding');
                        if (type === PaymentType.STARTUP_REGISTRATION) navigate('/startup-reg');
                        if (type === PaymentType.MENTOR_MEETING) navigate('/mentormeetingsdashboard');
                        if (type === PaymentType.STARTUP_IDEAS) navigate('/');
                    }, 1000);

                    return;
                }

                /* ----------------------------
                   USER ID CHECK FIXED HERE
                ---------------------------- */
                let userId = null;

                if (type !== PaymentType.EVENT) {
                    if (type === PaymentType.MATRIMONY) {
                        userId = matrimonyUserId;
                    } else if (
                        type === PaymentType.SUBSCRIPTION ||
                        type === PaymentType.CRM ||
                        type === PaymentType.FUNDING||
                        type === PaymentType.MENTOR_MEETING  
                    ) {
                        userId = startupId;
                    }

                    // FIXED: Startup Ideas does NOT need login
                    if (
                        !userId &&
                        type !== PaymentType.STARTUP_REGISTRATION &&
                        type !== PaymentType.STARTUP_IDEAS
                    ) {
                        toast.update(toastId, {
                            render: "User not authenticated. Please login again.",
                            type: "error",
                            isLoading: false,
                            autoClose: 5000
                        });

                        setTimeout(() => {
                            if (type === PaymentType.MATRIMONY) navigate('/matrimony/login');
                            else navigate('/login');
                        }, 1000);

                        return;
                    }
                }

                /* ----------------------------
                   FETCH REGISTRATION DATA
                ---------------------------- */
                let registrationData;

                const map = {
                    [PaymentType.EVENT]: "event_registration",
                    [PaymentType.SUBSCRIPTION]: "subscription_plan",
                    [PaymentType.MATRIMONY]: "subscription_plan",
                    [PaymentType.CRM]: "crm_plan",
                    [PaymentType.FUNDING]: "funding_data",
                    [PaymentType.STARTUP_REGISTRATION]: "startup_registration",
                    [PaymentType.STARTUP_IDEAS]: "startup_session_booking",
                    [PaymentType.MENTOR_MEETING]: "mentor_meeting_booking"
                };

                const storageKey = map[type];

                try {
                    const raw = sessionStorage.getItem(storageKey);
                    if (!raw) throw new Error("Stored payment session info lost");
                    registrationData = JSON.parse(raw);
                } catch (error) {
                    toast.update(toastId, {
                        render: `${error.message}. Please retry`,
                        type: "error",
                        isLoading: false,
                        autoClose: 5000
                    });

                    setTimeout(() => {
                        if (type === PaymentType.EVENT) navigate('/events');
                        if (type === PaymentType.CRM) navigate('/crm');
                        if (type === PaymentType.MATRIMONY) navigate('/matrimony');
                        if (type === PaymentType.SUBSCRIPTION || type === PaymentType.FUNDING) navigate('/funding');
                        if (type === PaymentType.STARTUP_REGISTRATION) navigate('/startup-reg');
                        if (type === PaymentType.MENTOR_MEETING) navigate('/mentormeetingsdashboard');
                        if (type === PaymentType.STARTUP_IDEAS) navigate('/');
                    }, 1000);

                    return;
                }

                /* ----------------------------
                   VERIFY PAYMENT
                ---------------------------- */
                const { verified, orderStatus, paymentStatus } = await verifyPayment(orderId);

                if (!verified) throw new Error("Payment not verified");

                const payment = paymentStatus[0];
                const transactionId = payment.cf_payment_id;

                const method = payment.payment_method.upi
                    ? `UPI (${payment.payment_method.upi.upi_id})`
                    : Object.keys(payment.payment_method)[0].toUpperCase();

                let result;

                /* ----------------------------
                   SUBSCRIPTION
                ---------------------------- */
                if (type === PaymentType.SUBSCRIPTION) {
                    const token = localStorage.getItem('Startuptoken');

                    result = await createSubscription({
                        userId,
                        membership_id: registrationData.id,
                        orderId: orderStatus.order_id,
                        title: registrationData.name,
                        price: orderStatus.order_amount,
                        type: 'Membership',
                        crmIncluded: registrationData.crmIncluded,
                        tenure: registrationData.tenure,
                        payment_status: "Paid",
                        transactionId,
                        paymentMethod: method
                    }, token);

                    if (result.statusCode === 201) {
                        await activateStartups(userId);

                        toast.update(toastId, {
                            render: "Subscription activated!",
                            type: "success",
                            isLoading: false,
                            autoClose: 4000
                        });

                        sessionStorage.removeItem("subscription_plan");
                        setTimeout(() => navigate('/admin-setting'), 1000);
                    }
                }

                /* ----------------------------
                   MATRIMONY
                ---------------------------- */
                else if (type === PaymentType.MATRIMONY) {
                    const token = localStorage.getItem('matrimonyToken');

                    result = await createSubscription({
                        userId,
                        membership_id: registrationData.id,
                        orderId: orderStatus.order_id,
                        title: registrationData.name,
                        price: orderStatus.order_amount,
                        type: 'Matrimony',
                        tenure: registrationData.tenure,
                        payment_status: "Paid",
                        transactionId,
                        paymentMethod: method,
                        matrimonyType: registrationData.matrimonyType
                    }, token);

                    toast.update(toastId, {
                        render: "Matrimony subscription activated!",
                        type: "success",
                        isLoading: false,
                        autoClose: 4000
                    });

                    sessionStorage.removeItem("subscription_plan");
                    setTimeout(() => navigate('/matrimony'), 1000);
                }

                /* ----------------------------
                   EVENT PAYMENT
                ---------------------------- */
                else if (type === PaymentType.EVENT) {
                    result = await registerEvent({
                        ...registrationData,
                        paymentStatus: "Paid",
                        transactionId
                    });

                    if (result.success || result.status === 201) {
                        await activateEvent(result.eventData.eventId, result.registrationId);

                        toast.update(toastId, {
                            render: "Event registration successful!",
                            type: "success",
                            isLoading: false,
                            autoClose: 3000
                        });

                        sessionStorage.removeItem("event_registration");
                        setTimeout(() => navigate('/events'), 1000);
                    }
                }

                /* ----------------------------
                   STARTUP IDEAS (YOUR NEW FLOW)
                ---------------------------- */
                else if (type === PaymentType.STARTUP_IDEAS) {
                    console.log(type)
                    const payload = {
                        ...registrationData,
                        paymentStatus: "Paid",
                        orderId: orderStatus.order_id,
                        transactionId,
                        paymentMethod: method,
                        amount: orderStatus.order_amount
                    };

                    console.log(payload)

                    const result = await saveStartupIdea(payload);

                    console.log("🔥 Startup Idea API Response:", result);

                    if (result.status === 201 || result.data?.success) {
                        toast.update(toastId, {
                            render: "Your Startup Ideas Session is booked!",
                            type: "success",
                            isLoading: false,
                            autoClose: 4000
                        });

                        sessionStorage.removeItem("startup_ideas_booking");

                        setTimeout(() => navigate('/'), 1000);
                    } else {
                        throw new Error(result.data?.message || "Failed to save Startup Idea booking");
                    }
                }


                   else if (type === PaymentType.MENTOR_MEETING) {
                    console.log(type)
                    const payload = {
                        ...registrationData,
                        paymentStatus: "Paid",
                        orderId: orderStatus.order_id,
                        paymentId:transactionId,
                        transactionId,
                        paymentMethod: method,
                        amount: orderStatus.order_amount
                    };

                    console.log(payload)

                    const result = await applyForMeeting(payload);

                    console.log("🔥Application recived:", result);

                    if (result.success) {
                        toast.update(toastId, {
                            render: "Applied for meeting!",
                            type: "success",
                            isLoading: false,
                            autoClose: 4000
                        });

                        sessionStorage.removeItem("mentor_meeting_booking");

                        setTimeout(() => navigate('/startupmeetings'), 1000);
                    } else {
                        console.log(result)
                        throw new Error(result.data?.message || "Failed to Apply in meeting");
                    }
                }

                /* ----------------------------
                   CRM PRICING
                ---------------------------- */
                else if (type === PaymentType.CRM) {
                    result = await storeCrmPricing({
                        userId,
                        planId: registrationData.id,
                        title: registrationData.description,
                        price: orderStatus.order_amount,
                        paymentStatus: "Paid",
                        orderId: orderStatus.order_id,
                        transactionId,
                        paymentMethod: method,
                        max_storage_size: registrationData.max_storage_size,
                        max_employees: registrationData.max_employees
                    });

                    toast.update(toastId, {
                        render: "CRM subscription activated!",
                        type: "success",
                        isLoading: false,
                        autoClose: 4000
                    });

                    sessionStorage.removeItem("crm_plan");
                    setTimeout(() => navigate('/crm'), 1000);
                }

                /* ----------------------------
                   FUNDING
                ---------------------------- */
                else if (type === PaymentType.FUNDING) {
                    result = await axios.post(`${apiUrl}/api/fundings`, {
                        ...registrationData,
                        userId,
                        paymentDetails: {
                            orderId: orderStatus.order_id,
                            transactionId,
                            paymentMethod: method,
                            status: "Paid",
                            amount: orderStatus.order_amount
                        }
                    });

                    toast.update(toastId, {
                        render: "Funding round created successfully!",
                        type: "success",
                        isLoading: false,
                        autoClose: 4000
                    });

                    sessionStorage.removeItem("funding_data");
                    setTimeout(() => navigate('/funding'), 1000);
                }

                /* ----------------------------
                   STARTUP REGISTRATION
                ---------------------------- */
                else if (type === PaymentType.STARTUP_REGISTRATION) {
                    result = await axios.post(`${apiUrl}/api/register`, {
                        ...registrationData,
                        paymentStatus: "Paid",
                        transactionId
                    });

                    toast.update(toastId, {
                        render: "Startup registration completed!",
                        type: "success",
                        isLoading: false,
                        autoClose: 4000
                    });

                    sessionStorage.removeItem("startup_registration");
                    setTimeout(() => navigate('/startup-dashboard'), 1000);
                }

            } catch (error) {
                console.error("Payment verification error:", error);

                toast.update(toastId, {
                    render: error.message || "Verification failed",
                    type: "error",
                    isLoading: false,
                    autoClose: 5000
                });

                // Redirect on failure
                setTimeout(() => {
                    if (type === PaymentType.EVENT) navigate('/events');
                    if (type === PaymentType.CRM) navigate('/crm-pricing');
                    if (type === PaymentType.MATRIMONY) navigate('/matrimony');
                    if (type === PaymentType.SUBSCRIPTION) navigate('/startup-reg');
                    if (type === PaymentType.FUNDING) navigate('/funding');
                    if (type === PaymentType.STARTUP_REGISTRATION) navigate('/startup-reg');
                    if (type === PaymentType.STARTUP_IDEAS) navigate('/');
                }, 1000);

            } finally {
                setLoading(false);
            }
        };

        runVerification();

        return () => toast.dismiss();
    }, [orderId, navigate, type, apiUrl]);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <ClipLoader size={48} />
                <p className="mt-4 text-gray-600">
                    {type === PaymentType.EVENT
                        ? "Finalizing your registration..."
                        : type === PaymentType.CRM
                            ? "Finalizing your CRM subscription..."
                            : type === PaymentType.MATRIMONY
                                ? "Finalizing your matrimony subscription..."
                                : type === PaymentType.FUNDING
                                    ? "Creating your funding round..."
                                    : type === PaymentType.STARTUP_REGISTRATION
                                        ? "Completing your startup registration..."
                                        : "Finalizing your payment..."}
                </p>
            </div>
        );
    }

    return null;
};

export default PaymentCallback;
